/** @format */

import React, { FC, useEffect, useState } from 'react'
import styled from 'styled-components'
import Checkbox from 'kpc-react/components/checkbox'
import _ from 'lodash'
import { _$ } from 'kpc-react'

interface checkItemProps {
  title: string
  checked: boolean
}

interface headerProps {
  headers: string[]
  className?: string
  visible: boolean
  changeHeader?: (value: checkItemProps[]) => void
}

const CostHeaders: FC<headerProps> = ({
  headers = [],
  className,
  visible = false,
  changeHeader
}) => {
  const [chosed, setChosed] = useState<checkItemProps[]>()
  const [allState, setAllState] = useState(false)
  const [indeter, setIndeter] = useState(false)
  // 设置checkbox数据
  useEffect(() => {
    const chosedList = headers.map(i => ({ title: i, checked: true }))
    setChosed(chosedList)
    setAllState(true)
  }, [headers])

  // 单个勾选
  const resetChosedByItem = (value: boolean, changedItem: string) => {
    const sourceList = _.cloneDeep(chosed)
    sourceList.forEach(i => {
      if (i.title === changedItem) {
        i.checked = value
      }
    })
    const checkedCount = sourceList.filter(i => i.checked === true).map(i => i.title)
    if (checkedCount.length === headers.length) {
      setAllState(true)
      setIndeter(false)
    } else if (checkedCount.length > 0) {
      setIndeter(true)
      setAllState(false)
    } else {
      setIndeter(false)
      setAllState(false)
    }
    changeHeader(sourceList)
    setChosed(sourceList)
  }
  // 全选change
  const dealAllChecked = (allStatus: boolean) => {
    const sourceList = chosed
    const newlist = sourceList.map(i => ({ ...i, checked: allStatus }))
    const checkedCount = newlist.filter(i => i.checked === true).map(i => i.title)
    if (checkedCount.length === headers.length) {
      setAllState(true)
    } else {
      setAllState(false)
    }
    setIndeter(false)
    changeHeader(newlist)
    setChosed(newlist)
  }
  // 全选
  const checkedAll = () => {
    return (
      <Checkbox
        indeterminate={indeter}
        value={allState}
        on$change-value={(c, value) => dealAllChecked(value)}
      >
        {_$('全选')}
      </Checkbox>
    )
  }
  return (
    <div className={className}>
      {visible ? (
        <>
          <div className="headerList">
            <p>{_$('表头显示设置')}</p>
            <p>{checkedAll()}</p>
            {
              <>
                {Array.isArray(chosed) &&
                  chosed.map((boxItem, index) => (
                    <p key={boxItem.title}>
                      <Checkbox
                        value={boxItem.checked}
                        on$change-value={(c, value) => {
                          resetChosedByItem(value, boxItem.title)
                        }}
                      >
                        {boxItem.title}
                      </Checkbox>
                    </p>
                  ))}
              </>
            }
          </div>
        </>
      ) : null}
    </div>
  )
}

export default styled(CostHeaders)`
  .headerList {
    position: absolute;
    min-height: 100px;
    max-height: 150px;
    overflow-y: scroll;
    width: 200px;
    background-color: #ffffff;
    padding: 16px;
    top: 100px;
    right: 0px;
    margin-top: 16px;
    box-shadow: -10px 10px 15px #ccc;
  }
`
